"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./FavoriteButton.css");
var ToggleButton_1 = require("../ToggleButton/ToggleButton");
var Icon_1 = require("../../../components/icon/Icon");
var react_1 = require("react");
var FavoriteButtonComp = function (props, ref) {
    var starIcon = react_1.useRef(null);
    react_1.useEffect(function () {
        var _a;
        if (props.isActive === undefined && props.startActive !== undefined) {
            (_a = starIcon.current) === null || _a === void 0 ? void 0 : _a.animate({ animationIndex: props.startActive ? 0 : 1 });
        }
    }, []);
    react_1.useEffect(function () {
        var _a;
        if (props.isActive !== undefined) {
            (_a = starIcon.current) === null || _a === void 0 ? void 0 : _a.animate({ animationIndex: props.isActive ? 0 : 1 });
        }
    }, [props.isActive]);
    return (React.createElement(ToggleButton_1.ToggleButtonFR, __assign({ ref: ref }, props, { className: classnames_1.default('FavoriteButton', props.className), onToggle: function (isActive, e) {
            var _a;
            if (props.isActive === undefined) {
                (_a = starIcon.current) === null || _a === void 0 ? void 0 : _a.animate({ animationIndex: isActive ? 0 : 1 });
            }
            if (props.onToggle) {
                props.onToggle(isActive, e);
            }
        } }),
        React.createElement(Icon_1.Icon, { ref: starIcon, type: Icon_1.IconType.star })));
};
exports.FavoriteButtonFR = React.forwardRef(FavoriteButtonComp);
exports.FavoriteButton = React.memo(exports.FavoriteButtonFR);
